import { combineReducers }  from "redux";
import OpenBankingReducer from "./OpenBankingReducer";
import ConfigurationReducer from "./ConfigurationReducer";

export default combineReducers({OpenBankingReducer,ConfigurationReducer});